import Resolution from 'engine/Resolution.js';
import {setCursorTrack, setCursorStep, setCursorShow} from 'actions/index.js';
import {setSelectedTrack} from 'actions/index.js';
import {setSelectedStep} from 'actions/index.js';
import {setPianoRollCursor} from 'actions/index.js';

const baseResolution = new Resolution(32, false);

// todo: add resolution here and have this be the source of truth for that
class Cursor {

    constructor(store) {
        this.store = store;

        // the cursor state is held at the resolution of 32 (i.e.
        // what we use to represent the pattern)

        this.step = 0;
        this.track = 0;
        this.group = 0;
        this.show = false;
    }

    set step(s) {
        this.store.dispatch(setCursorStep(s));
        this.updateRedux();
    }

    set track(t) {
        this.store.dispatch(setCursorTrack(t));
    }

    set show(s) {
        this.store.dispatch(setCursorShow(s));
    }

    get track() {
        return this.store.getState().cursor.track;
    }

    get step() {
        return this.store.getState().cursor.step;
    }

    get show() {
        return this.store.getState().cursor.show;
    }

    getJson() {
        return {
            step: this.step,
            track: this.track
        };
    }

    getStep(resolution) {
        let step = resolution === undefined ? this.step :
            resolution.transformStepAtResolution2(this.step, baseResolution);

        return step;
    }

    setStep(step, resolution) {
        this.step = baseResolution.transformStepAtResolution2(step, resolution);
    }

    get resolution() {
        return this.store.getState().sequencer.resolution
    }

    updateRedux() {
        this.store.dispatch(setSelectedTrack(this.track));
        this.store.dispatch(setSelectedStep(this.getStep(this.resolution)));
        this.store.dispatch(setPianoRollCursor(this.getStep(this.resolution)));
    }
}

export default Cursor;

